package com.vidaensupalabra.vsp.datos

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.style
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

object BibleUtils {
    private val bookAbbreviations = mapOf(
        "Génesis" to "GEN", "Éxodo" to "EXO", "Levítico" to "LEV", "Números" to "NUM", "Deuteronomio" to "DEU",
        "Josué" to "JOS", "Jueces" to "JDG", "Rut" to "RUT", "1 Samuel" to "1SA", "2 Samuel" to "2SA",
        "1 Reyes" to "1KI", "2 Reyes" to "2KI", "1 Crónicas" to "1CH", "2 Crónicas" to "2CH", "Esdras" to "EZR",
        "Nehemías" to "NEH", "Ester" to "EST", "Job" to "JOB", "Salmo" to "PSA", "Salmos" to "PSA", "Proverbios" to "PRO",
        "Eclesiastés" to "ECC", "Cantares" to "SNG", "Isaías" to "ISA", "Jeremías" to "JER", "Lamentaciones" to "LAM",
        "Ezequiel" to "EZK", "Daniel" to "DAN", "Oseas" to "HOS", "Joel" to "JOL", "Amós" to "AMO",
        "Abdías" to "OBA", "Jonás" to "JON", "Miqueas" to "MIC", "Nahúm" to "NAM", "Habacuc" to "HAB",
        "Sofonías" to "ZEP", "Hageo" to "HAG", "Zacarías" to "ZEC", "Malaquías" to "MAL",
        "Mateo" to "MAT", "Marcos" to "MRK", "Lucas" to "LUK", "Juan" to "JHN", "Hechos" to "ACT",
        "Romanos" to "ROM", "1 Corintios" to "1CO", "2 Corintios" to "2CO", "Gálatas" to "GAL", "Efesios" to "EPH",
        "Filipenses" to "PHP", "Colosenses" to "COL", "1 Tesalonicenses" to "1TH", "2 Tesalonicenses" to "2TH",
        "1 Timoteo" to "1TI", "2 Timoteo" to "2TI", "Tito" to "TIT", "Filemón" to "PHM", "Hebreos" to "HEB",
        "Santiago" to "JAS", "1 Pedro" to "1PE", "2 Pedro" to "2PE", "1 Juan" to "1JN", "2 Juan" to "2JN",
        "3 Juan" to "3JN", "Judas" to "JUD", "Apocalipsis" to "REV"
    )

    fun convertReferenceToBibleComFormat(reference: String): String {
        val bookName = bookAbbreviations.keys
            .sortedByDescending { it.length }
            .find { reference.startsWith(it, ignoreCase = true) } ?: return ""

        val chapterInfo = reference.substring(bookName.length).trim()
        val chapter = if (chapterInfo.isEmpty()) "1" else chapterInfo.takeWhile { it.isDigit() }

        val abbreviation = bookAbbreviations[bookName] ?: return ""
        return "$abbreviation.$chapter"
    }

    @Composable
    fun FormatBibleText(rawText: String, baseFontSize: Int) {
        val lines = rawText.lines()
        val verseRegex = Regex("^(\\d+)\\s+(.*)")
        lines.forEach { line ->
            if (line.isNotBlank()) {
                val match = verseRegex.find(line)
                if (match != null) {
                    val verseNumber = match.groupValues[1]
                    val verseText = match.groupValues[2]
                    VerseNumber(verseNumber, baseFontSize)
                    Text(verseText)
                    Br()
                    Br()
                } else {
                    Text(line)
                    Br()
                    Br()
                }
            }
        }
    }

    @Composable
    private fun VerseNumber(number: String, baseFontSize: Int) {
        Span(attrs = {
            style {
                fontWeight("bold")
                fontSize((baseFontSize * 0.7).px)
                property("vertical-align", "super")
                property("margin-right", "4px")
            }
        }) {
            Text(number)
        }
    }
}